import React, { FC } from "react";
import FeatherIcon from "feather-icons-react";
import { useTranslation } from "react-i18next";

import { IconButton, Stack, Typography } from "@components/base";
import IconAssignUsers from "@icons/AssignUsers";

interface EntityAssignmentHeader {
  onClose: () => void;
}

const EntityAssignmentHeader: FC<EntityAssignmentHeader> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack direction="row" alignItems="center" spacing={2}>
        <IconAssignUsers sx={{ fontSize: 24 }} />
        <Typography variant="subtitle1" fontWeight={600}>
          {t("entityAssignment.headerTitle", "Assign entities")}
        </Typography>
      </Stack>
      <IconButton onClick={onClose}>
        <FeatherIcon icon="x" size={24} />
      </IconButton>
    </Stack>
  );
};

export default EntityAssignmentHeader;
